import { ItemList } from '../../orm'

class AdminIncomingAsteriskFaxQueueList extends ItemList {
    getEntityKey() {
        return "admin/incoming_asterisk_fax_queue"
    }
}

export const adminIncomingAsteriskFaxQueueList = new AdminIncomingAsteriskFaxQueueList("admin_incoming_asterisk_fax_qeueu__default")
